export default "__VITE_ASSET__f89c35e2__"